jQuery(document).ready(function($) {
	const header = document.querySelector('.jupiterx-header');

	if (header) {
		const updateHeaderHeight = function () {
			document.documentElement.style.setProperty('--site-header-height', header.getBoundingClientRect().height + 'px');
		};

		updateHeaderHeight();

		if (window.ResizeObserver) {
			const headerObserver = new ResizeObserver(updateHeaderHeight);
			headerObserver.observe(header);
		} else {
			window.addEventListener('resize', updateHeaderHeight);
			window.addEventListener('load', updateHeaderHeight);
		}
	}

	//jQuery for Programmation accordion on page programmation
	$('.conference-accordion').click(function (){
		$(this).parent('.conference-container').toggleClass('active-conf');
		console.log(window.location.hash);
	});

	setTimeout(function(){
		var current = window.location.href;
		var hash = window.location.hash;
		var current = current.split('#conf-');
		if(current.length>1) {	
	    	$('.elementor-tab-title').removeClass('elementor-active');
	    	$('.elementor-tab-content').removeClass('elementor-active');
	    	var parent = $(hash).parents('.elementor-tab-content');
	    	var number = parent.attr("data-tab");
	    	$('.elementor-tab-title[data-tab="'+number+'"]').addClass('elementor-active');
	    	$('.elementor-tab-content[data-tab="'+number+'"]').addClass('elementor-active');
	    	$('.elementor-tab-content').hide();
	    	$('.elementor-tab-content[data-tab="'+number+'"]').show();
	    	$(hash).addClass('active-conf');
	    	$([document.documentElement, document.body]).animate({
				scrollTop: $(".active-conf").offset().top - 50
			}, 2000);
		}
	}, 0);
	$('.elementor-tab-title').click(function(){
		$('.elementor-tab-content').hide();
		$('.elementor-tab-content.elementor-active').show();
	})

	//End of jQuery for Programmation accordion
});
